import React from 'react';
import LinkIcon from '@mui/icons-material/Link';
import { Typography } from '@mui/material';

export const IconLinkedBundleText = () => (
  <Typography
    sx={{
      fontFamily: 'Open Sans',
    }}
  >
    <LinkIcon
      sx={{ fontSize: '3rem' }}
      fontSize="large"
      style={{ color: '#266DCC', verticalAlign: 'middle', textAlign: 'center' }}
    />
    <span
      style={{
        color: '#266DCC',
        paddingLeft: '4px',
        fontWeight: '600',
        fontSize: '1.5rem',
        verticalAlign: 'middle',
        textAlign: 'center',
      }}
    >
      Linked Bundles
    </span>
  </Typography>
);
